import { getAPIEndpoint } from "./getAPIEndpoint";

const contentTypes: Record<string, string> = {
  json: "application/json",
  form: "application/x-www-form-urlencoded",
  html: "text/html",
};

let isRefreshing = false;
let refreshPromise: Promise<string> | null = null;

async function refreshAccessToken() {
  if (isRefreshing && refreshPromise) {
    return refreshPromise;
  }
  isRefreshing = true;

  refreshPromise = fetch(`${getAPIEndpoint()}auth/token/refresh/`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    credentials: "include",
  })
    .then(async (res) => {
      if (!res.ok) throw new Error("Refresh failed");
      const data = await res.json();
      localStorage.setItem("access", data.access);
      return data.access;
    })
    .catch((error) => {
      console.error("Refresh token failed:", error);
      return null;
    })
    .finally(() => {
      isRefreshing = false;
      refreshPromise = null;
    });

  return refreshPromise;
}

const makeRequest = async (
  url: string,
  method: string,
  payload?: any,
  params?: any,
  contentType: string = "json",
) => {
  const queryParamsMethods = ["GET", "HEAD", "OPTIONS"];
  let urlParams = "";

  if (params) {
    const urlPayload = params as Record<string, string>;
    for (const key in urlPayload) {
      urlParams += `&${key}=${urlPayload[key]}`;
    }
  }

  const endpoint = `${getAPIEndpoint()}${url}${urlParams.length > 0 ? `?${urlParams.substring(1)}` : ""}`;

  // Helper to perform fetch
  const doFetch = async (token?: string) =>
    fetch(endpoint, {
      method,
      headers: {
        "Content-Type": contentTypes[contentType],
        ...(token && !url.includes("login")
          ? { Authorization: `Bearer ${token}` }
          : {}),
      },
      credentials: "include",
      ...(queryParamsMethods.includes(method)
        ? {}
        : { body: JSON.stringify(payload) }),
    });

  const access = localStorage.getItem("access");
  let response = await doFetch(access || undefined);

  // If access token expired
  if (response.status === 401 && !url.includes("login") && access) {
    const newToken = await refreshAccessToken();
    if (newToken) {
      response = await doFetch(newToken);
    } else {
      localStorage.clear();
      window.location.reload();
    }
  }

  return response;
};

export default makeRequest;
